<template>
	<v-card class="buy-with-confidence" elevation="0" :ripple="false">
		<v-img :src="require('@/assets/bg/howItWorksVouchers.png')"  position="top"/>
		<div class="text-panel">
			<h4 class="header">How it works</h4>
			<p class="description">Discover how to purchase vouchers effortlessly and learn tips on saving for your next big spend.</p>
		</div>
	</v-card>
</template>

<script setup lang="ts">
</script>

<style scoped>
.buy-with-confidence {
	border-radius: 12px;
	overflow: hidden;
	height: 295px;
	position: relative;
}
.buy-with-confidence:hover,
.buy-with-confidence:active,
.buy-with-confidence.v-card--hover,
.buy-with-confidence.v-card--active {
	background: inherit !important;
	box-shadow: none !important;
}

.text-panel {
	background: #E8E3E2;
	padding: 20px;
	color: #413655;
	padding-bottom: 32px;
}

.text-panel p {
	margin: 0;
	font-size: 14px;
	line-height: 1.4;
}

.header {
	margin: 0;
	font-size: 16px;
	margin-bottom: 8px;
}

.description {
	margin: 0;
	font-size: 14px;
}

.paymentMethods {
	position: absolute;
	width: 200px;
	margin-top: -30px;
	margin-left: 20px;
}

/* Mobile dark mode */
:root.mobile-dark-mode .text-panel {
	background: var(--background-color);
	color: var(--text-color);
}
:root.mobile-dark-mode .paymentMethods {
	filter: brightness(0.85);
}

</style>